import React from 'react';
import {motion, TargetAndTransition, transform} from 'framer-motion';
import styled from 'styled-components';
import {useScrollToAnimate} from '../../../shared';
import {easing} from 'epic-ue-theme';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const Styled = styled(motion.div)`
    height: 100%;
    width: 100%;
`;
export interface TranslateYOnViewWrapProps {
    yOffset?: number;
    children: React.ReactNode;
    id: string;
    duration?: number;
    delay?: number;
    disable?: boolean;
}

export const TranslateYOnViewWrap = ({
    children,
    yOffset = 30,
    duration = 1,
    delay = 0,
    id,
    disable
}: TranslateYOnViewWrapProps): JSX.Element => {
    const {ref, percentVisible, elId} = useScrollToAnimate({
        id,
        type: 'translateY'
    });

    const reducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');

    if (disable || reducedMotion) {
        return <>{children}</>;
    }

    //Fade in so that it is fully opaque when 25% visible
    const opacity = transform(percentVisible, [0, 0.25], [0, 1]);

    //Translate so that the element returns to its original spot when its 50% visible
    const yOutput = transform(percentVisible, [0, 0.5], [yOffset, 0]);

    const animate = {
        translateY: yOutput,
        opacity,
        transition: {delay, duration, easing} as TargetAndTransition
    };

    return (
        <Styled ref={ref} className="translatey-motion" id={elId} animate={animate} initial={false}>
            {children}
        </Styled>
    );
};
